import { throwOnError } from './utils';

type Paginated<T> = {
  items: T[];
  count: number;
  next: string | null;
  prev: string | null;
  per_page: number;
};

type GetCVSApplicationsResponse = Paginated<{
  order_id: string;
  canceled_at: string | null;
  receipt_no: string;
  amount: number;
  name1: string;
  name2: string;
  pay_limit: string;
  done_at: string;
  transaction_id: string | null;
  user: {
    id: string;
  };
}>;

export const getCvsApplications = (id: string, query = '') =>
  fetch(`/api/private-moneys/${id}/cvs-authorizations?${query}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then(throwOnError<GetCVSApplicationsResponse>);

export const cancelCvsApplication = (orderId: string) =>
  fetch(`/api/accounts/cvs-authorizations/${orderId}`, {
    method: 'PATCH',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: (window as any)._csrf_token }),
  });
